import React from "react";
import { Preloader } from "../../../common/ui/Preloader/preloader";

export const AccountsLoading = () => {
  return (
    <div className="data-card__loading-container">
      <Preloader small={true} />
      <p className="data-card__text data-card__text_loading">
        Загрузка данных...
      </p>
    </div>
  );
};
